if (!window.__productVideoControlsInstalled) {
  window.__productVideoControlsInstalled = true;

  const syncPlaybackButton = (media, video) => {
    const button = media.querySelector('[data-product-video-play-toggle]');
    if (!button || !video) return;

    button.removeAttribute('hidden');
    button.setAttribute('aria-pressed', String(!video.paused));
    button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    button.querySelector('[data-video-playing]').toggleAttribute('hidden', video.paused);
    button.querySelector('[data-video-paused]').toggleAttribute('hidden', !video.paused);

    if (button.dataset.boundVideo === 'true') return;
    button.dataset.boundVideo = 'true';
    video.addEventListener('play', () => syncPlaybackButton(media, video));
    video.addEventListener('pause', () => syncPlaybackButton(media, video));
    video.addEventListener('ended', () => syncPlaybackButton(media, video));
  };

  const setupMedia = (media) => {
    const deferredMedia = media.querySelector('deferred-media[data-product-video-controls]');
    if (!deferredMedia || media.dataset.productVideoControlsReady === 'true') return;

    media.dataset.productVideoControlsReady = 'true';
    const observer = new MutationObserver(() => {
      const video = deferredMedia.querySelector('video');
      if (video) syncPlaybackButton(media, video);
    });
    observer.observe(deferredMedia, { childList: true, subtree: true });

    const video = deferredMedia.querySelector('video');
    if (video) syncPlaybackButton(media, video);
  };

  const scanMedia = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches('.product-media')) setupMedia(node);
    node.querySelectorAll?.('.product-media').forEach(setupMedia);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scanMedia(document.documentElement), { once: true });
  } else {
    scanMedia(document.documentElement);
  }

  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(scanMedia));
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const media = target.closest('.product-media');
    if (!media) return;

    const soundButton = target.closest('[data-product-video-audio-toggle]');
    if (soundButton) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const video = media.querySelector('deferred-media[data-product-video-controls] video');
      if (!video) return;

      video.muted = !video.muted;
      soundButton.setAttribute('aria-pressed', String(!video.muted));
      soundButton.setAttribute('aria-label', video.muted ? soundButton.dataset.soundOnLabel : soundButton.dataset.soundOffLabel);
      soundButton.querySelector('[data-sound-on]').toggleAttribute('hidden', video.muted);
      soundButton.querySelector('[data-sound-off]').toggleAttribute('hidden', !video.muted);
      return;
    }

    const playButton = target.closest('[data-product-video-play-toggle]');
    if (playButton) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const video = media.querySelector('deferred-media[data-product-video-controls] video');
      if (!video) return;

      if (video.paused) {
        video.play().catch(() => syncPlaybackButton(media, video));
      } else {
        video.pause();
      }
      return;
    }

    const deferredMedia = target.closest('deferred-media[data-product-video-controls]');
    if (!deferredMedia) return;

    if (target.closest('.video-interaction-hint')) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }

    if (target.closest('.deferred-media__poster-button')) {
      media.classList.add('is-controls-visible');
      return;
    }

    const controlsVisible = media.classList.contains('is-controls-visible');
    media.classList.toggle('is-controls-visible', !controlsVisible);
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }, true);
  
  document.addEventListener('slideshow:select', (event) => {
    const slideshow = event.target;
    const detail = event.detail;

    if (!(slideshow instanceof Element) || !detail?.userInitiated || detail.previousIndex === detail.index) return;

    const gallery = slideshow.closest('media-gallery');
    if (!gallery) return;

    gallery.querySelectorAll('deferred-media[data-product-video-controls] video').forEach((video) => {
      video.pause();
    });
  });
}